module.exports = __webpack_public_path__ + "static/img/icon-warning.3769d089.svg";